import Settings from "@assets/javascripts/settings";
const projectUnitCostColumn = [
  {
    name: "",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.CHECKBOX,
    check_all: false,
  },
  {
    attribute: "unit_cost_type",
    name: "費目",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT,
  },
  {
    attribute: "name",
    name: "名称",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-left",
  },
  // 吉田直土木様専用: 名称の右隣の備考列。デフォルトは非表示(is_show: false)とし、
  // MainBox.vueのapplyYoshidanaoColumnVisibility()でisYoshidanaoの時のみ表示させる。
  {
    attribute: "remarks",
    name: "備考",
    is_show: false,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-left",
    width: "150px",
  },
  {
    attribute: "unit_cost_category",
    name: "分類",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
    // 文字列(選択式)の列は左寄せに統一。位置非依存に列定義自体へclassを指定する
    // (工種名列の左寄せ修正時と同じ方針、tableHelper.js内の他列コメント参照)。
    class: "text-left",
  },
  {
    // 吉田直土木様専用の列幅上書き(applyYoshidanaoColumnVisibility)で位置非依存に
    // 参照できるよう、実際のバックエンドキー名(unit_cost)をattributeとして明示しておく。
    attribute: "unit_cost",
    name: "実行予算単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "project_unit",
    name: "単位",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "project_supplier",
    name: "会社名",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "standard_unit_cost",
    name: "積算単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    // 吉田直土木様専用の黄色背景強調(applyYoshidanaoColumnVisibility)で位置非依存に
    // 参照できるよう、実際のバックエンドキー名(estimated_unit_cost)をattributeとして明示しておく。
    attribute: "estimated_unit_cost",
    name: "見積単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "other_unit_cost1",
    name: "その他単価1",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "other_unit_cost2",
    name: "その他単価2",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "project_book_account",
    name: "科目",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "code",
    name: "コード",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
  },
  {
    attribute: "eight_hours_unit_cost",
    name: "8時間単価",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_unit_cost",
    name: "時間外",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_quantity",
    name: "時間外時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_amount",
    name: "時間外合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    // type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "estimate_night_hour_unit_cost",
    name: "深夜割増",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_night_hour_quantity",
    name: "深夜割増時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_night_hour_amount",
    name: "深夜割増合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    // type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "estimate_saturday_hour_unit_cost",
    name: "休日割増",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_saturday_hour_quantity",
    name: "休日割増時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_saturday_hour_amount",
    name: "休日割増合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    // type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "paid_leave_reserve",
    name: "有給引当",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "normal_wage",
    name: "通常",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "overtime_wage",
    name: "残業",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "nighttime_wage",
    name: "深夜",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "holiday_wage",
    name: "休日",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance1",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance2",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance3",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance4",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance5",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "時間単価",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "作成日",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  {
    name: "更新日",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  {
    name: "経費率",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  {
    name: "経費率数値",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  {
    name: "積算",
    is_show: false,
    is_number: false,
    type: Settings.CELL_TYPE.ICON,
  },
  {
    name: "実行",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.ICON,
  },
  {
    name: "削除",
    is_show: true,
    type: Settings.CELL_TYPE.BUTTON,
    class:
      "btn btn-secondary border font-size-11 py-0 px-1 creatework_button text-nowrap mx-2",
    text: "削除",
  },
];

const columnsLaborSalary = [
  "8時間単価",
  "時間外",
  "時間外時間数",
  "時間外合計金額",
  "深夜割増",
  "深夜割増時間数",
  "深夜割増合計金額",
  "休日割増",
  "休日割増時間数",
  "休日割増合計金額",
  "有給引当",
  "通常",
  "残業",
  "深夜",
  "休日",
  "単価",
  "単価",
  "単価",
  "単価",
  "単価",
];

const columnsMachinery = ["時間単価"];

const columnsDefault = [
  "費目",
  "名称",
  "分類",
  "実行予算単価",
  "単位",
  "会社名",
  "積算単価",
  "見積単価",
  "その他単価1",
  "その他単価2",
  "科目",
  "コード",
  "作成日",
  "更新日",
  "経費率",
  "経費率数値",
  "実行",
  "削除",
  "",
];

const conditionType = {
  all: "全て",
  labor: "労務費",
  machinery: "車輌機械費",
  machinery_special: "機械費・運搬費",
};

const companyUnitCostColumn = [
  {
    name: "",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.CHECKBOX,
    check_all: false,
    width: "40px",
  },
  {
    attribute: "unit_cost_type",
    name: "費目",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT,
  },
  {
    attribute: "name",
    name: "名称",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
  },
  // 吉田直土木様専用: 名称の右隣の備考列。デフォルトは非表示(is_show: false)とし、
  // MainBox.vueのapplyYoshidanaoColumnVisibility()でisYoshidanaoの時のみ表示させる。
  {
    attribute: "remarks",
    name: "備考",
    is_show: false,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-left",
    width: "150px",
  },
  {
    attribute: "company_unit_cost_category",
    name: "分類",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
    // 文字列(選択式)の列は左寄せに統一。位置非依存に列定義自体へclassを指定する
    // (工種名列の左寄せ修正時と同じ方針、tableHelper.js内の他列コメント参照)。
    class: "text-left",
  },
  {
    // 吉田直土木様専用の列幅上書き(applyYoshidanaoColumnVisibility)で位置非依存に
    // 参照できるよう、実際のバックエンドキー名(unit_cost)をattributeとして明示しておく。
    attribute: "unit_cost",
    name: "実行予算単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "company_unit",
    name: "単位",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "company_supplier",
    name: "会社名",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "standard_unit_cost",
    name: "積算単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    // 吉田直土木様専用の黄色背景強調(applyYoshidanaoColumnVisibility)で位置非依存に
    // 参照できるよう、実際のバックエンドキー名(estimated_unit_cost)をattributeとして明示しておく。
    attribute: "estimated_unit_cost",
    name: "見積単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "other_unit_cost1",
    name: "その他単価1",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "other_unit_cost2",
    name: "その他単価2",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "company_book_account",
    name: "科目",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "code",
    name: "コード",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
  },
  {
    attribute: "eight_hours_unit_cost",
    name: "8時間単価",
    is_show: false,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_unit_cost",
    name: "時間外",
    is_show: false,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_quantity",
    name: "時間外時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_amount",
    name: "時間外合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "estimate_night_hour_unit_cost",
    name: "深夜割増",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_night_hour_quantity",
    name: "深夜割増時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_night_hour_amount",
    name: "深夜割増合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "estimate_saturday_hour_unit_cost",
    name: "休日割増",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_saturday_hour_quantity",
    name: "休日割増時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_saturday_hour_amount",
    name: "休日割増合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "paid_leave_reserve",
    name: "有給引当",
    is_show: false,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "normal_wage",
    name: "通常",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "overtime_wage",
    name: "残業",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "nighttime_wage",
    name: "深夜",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "holiday_wage",
    name: "休日",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance1",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance2",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance3",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance4",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance5",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "時間単価",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "作成日",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  {
    name: "更新日",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  // {
  //   name: "経費率",
  //   is_show: true,
  //   is_number: false,
  //   width: "86px",
  // },
  {
    name: "削除",
    is_show: true,
    type: Settings.CELL_TYPE.BUTTON,
    class:
      "btn btn-secondary border font-size-11 py-0 px-1 creatework_button text-nowrap mx-2",
    text: "削除",
    width: "60px",
  },
];

const userUnitCostCopyColumn = [
  {
    name: "",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.CHECKBOX,
    check_all: false,
    width: "35px",
    thClass: "sticky-checkbox-col",
    tdClass: "sticky-checkbox-col",
  },
  {
    name: "費目",
    is_show: true,
    is_number: false,
    class: "text-center",
    width: "100px",
  },
  {
    name: "名称",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "260px",
  },
  {
    attribute: "remarks",
    name: "備考",
    is_show: false,
    is_number: false,
    class: "text-left",
    width: "160px",
  },
  {
    name: "分類",
    is_show: true,
    is_number: false,
    width: "160px",
  },
  {
    // 吉田直土木様専用の並び替え(ModalImportUser.vueのapplyYoshidanaoColumnVisibility)で
    // 対象列を表示位置に依存せず特定するためのメタ情報(remarks列のattributeと同じ扱い。
    // BaseLine.vueのcolumn_attributeキーとは無関係で、列数・キー数には影響しない)
    attribute: "unit_cost",
    name: "実行予算単価",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "単位",
    is_show: true,
    is_number: false,
    width: "70px",
  },
  {
    name: "会社名",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "200px",
  },
  {
    name: "積算単価",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "見積単価",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "その他単価1",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
    thClass: "copy-modal-th-divider",
    tdClass: "copy-modal-divider",
  },
  {
    name: "その他単価2",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "科目",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "130px",
  },
  {
    name: "コード",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "100px",
  },
];

const companyUnitCostCopyColumn = [
  {
    name: "",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.CHECKBOX,
    check_all: false,
    width: "35px",
    thClass: "sticky-checkbox-col",
    tdClass: "sticky-checkbox-col",
  },
  {
    name: "費目",
    is_show: true,
    is_number: false,
    class: "text-center",
    width: "100px",
  },
  {
    name: "名称",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "260px",
  },
  {
    attribute: "remarks",
    name: "備考",
    is_show: false,
    is_number: false,
    class: "text-left",
    width: "160px",
  },
  {
    name: "分類",
    is_show: true,
    is_number: false,
    width: "160px",
  },
  {
    // 吉田直土木様専用の並び替え(ModalImportCompany.vueのapplyYoshidanaoColumnVisibility)で
    // 対象列を表示位置に依存せず特定するためのメタ情報(remarks列のattributeと同じ扱い。
    // BaseLine.vueのcolumn_attributeキーとは無関係で、列数・キー数には影響しない)
    attribute: "unit_cost",
    name: "実行予算単価",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "単位",
    is_show: true,
    is_number: false,
    width: "70px",
  },
  {
    name: "会社名",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "200px",
  },
  {
    name: "積算単価",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "見積単価",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "その他単価1",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
    thClass: "copy-modal-th-divider",
    tdClass: "copy-modal-divider",
  },
  {
    name: "その他単価2",
    is_show: true,
    is_number: true,
    class: "text-right",
    width: "130px",
  },
  {
    name: "科目",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "130px",
  },
  {
    name: "コード",
    is_show: true,
    is_number: false,
    class: "text-left",
    width: "100px",
  },
];

const userUnitCostColumn = [
  {
    name: "",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.CHECKBOX,
    check_all: false,
    width: "40px",
  },
  {
    attribute: "unit_cost_type",
    name: "費目",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT,
  },
  {
    attribute: "name",
    name: "名称",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
  },
  // 吉田直土木様専用: 名称の右隣の備考列。デフォルトは非表示(is_show: false)とし、
  // MainBox.vueのapplyYoshidanaoColumnVisibility()でisYoshidanaoの時のみ表示させる。
  {
    attribute: "remarks",
    name: "備考",
    is_show: false,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-left",
    width: "150px",
  },
  {
    attribute: "user_unit_cost_category",
    name: "分類",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
    // 文字列(選択式)の列は左寄せに統一。位置非依存に列定義自体へclassを指定する
    // (工種名列の左寄せ修正時と同じ方針、tableHelper.js内の他列コメント参照)。
    class: "text-left",
  },
  {
    // 吉田直土木様専用の列幅上書き(applyYoshidanaoColumnVisibility)で位置非依存に
    // 参照できるよう、実際のバックエンドキー名(unit_cost)をattributeとして明示しておく。
    attribute: "unit_cost",
    name: "実行予算単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "user_unit",
    name: "単位",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "user_supplier",
    name: "会社名",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "standard_unit_cost",
    name: "積算単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    // 吉田直土木様専用の黄色背景強調(applyYoshidanaoColumnVisibility)で位置非依存に
    // 参照できるよう、実際のバックエンドキー名(estimated_unit_cost)をattributeとして明示しておく。
    attribute: "estimated_unit_cost",
    name: "見積単価",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "other_unit_cost1",
    name: "その他単価1",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "other_unit_cost2",
    name: "その他単価2",
    is_show: true,
    is_number: true,
    minus: true,
    type: Settings.CELL_TYPE.INPUT,
    class: "text-right",
  },
  {
    attribute: "user_book_account",
    name: "科目",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.SELECT_TAGGABLE,
  },
  {
    attribute: "code",
    name: "コード",
    is_show: true,
    is_number: false,
    type: Settings.CELL_TYPE.INPUT,
  },
  {
    attribute: "eight_hours_unit_cost",
    name: "8時間単価",
    is_show: false,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_unit_cost",
    name: "時間外",
    is_show: false,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_quantity",
    name: "時間外時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_outside_hour_amount",
    name: "時間外合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "estimate_night_hour_unit_cost",
    name: "深夜割増",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_night_hour_quantity",
    name: "深夜割増時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_night_hour_amount",
    name: "深夜割増合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "estimate_saturday_hour_unit_cost",
    name: "休日割増",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_saturday_hour_quantity",
    name: "休日割増時間数",
    is_show: true,
    is_number: true,
    // 吉田直土木様(3-6): 「時間数」は小数第1位まで(0.1刻み)の入力を許容する。
    // precision: 0のままだとInputCell→VueNumericが入力中に整数へ四捨五入してしまい、
    // 1.5と入力しても即2に化ける(客先報告の「小数が自動で四捨五入される」の原因)。
    // この列は吉田直土木様の労務費/外注費タブでのみ表示される(MainBox.vueの
    // applyYoshidanaoColumnVisibility参照)ため他社への影響はない。DBはdecimal(13,3)。
    precision: 1,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "estimate_saturday_hour_amount",
    name: "休日割増合計金額",
    is_show: true,
    is_number: true,
    precision: 0,
    class: "unit_cost_cell",
    // 単価×時間数の計算結果を表示するだけで手入力できないため、常にグレーアウト表示にする
    // (対応1、2026-08 客先要望)。DefaultCell.vueの<td>にこのtdClassがそのまま渡る。
    tdClass: "cell-locked"
  },
  {
    attribute: "paid_leave_reserve",
    name: "有給引当",
    is_show: false,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "normal_wage",
    name: "通常",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "overtime_wage",
    name: "残業",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "nighttime_wage",
    name: "深夜",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    attribute: "holiday_wage",
    name: "休日",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance1",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance2",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance3",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance4",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "単価",
    is_show: true,
    is_number: true,
    precision: 0,
    code: "allowance5",
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "時間単価",
    is_show: true,
    is_number: true,
    precision: 0,
    type: Settings.CELL_TYPE.INPUT,
    class: "unit_cost_cell"
  },
  {
    name: "作成日",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  {
    name: "更新日",
    is_show: true,
    is_number: false,
    width: "86px",
  },
  // {
  //   name: "経費率",
  //   is_show: true,
  //   is_number: false,
  //   width: "86px",
  // },
  {
    name: "削除",
    is_show: true,
    type: Settings.CELL_TYPE.BUTTON,
    class:
      "btn btn-secondary border font-size-11 py-0 px-1 creatework_button text-nowrap mx-2",
    text: "削除",
    width: "60px",
  },
];

export {
  projectUnitCostColumn,
  columnsLaborSalary,
  columnsMachinery,
  columnsDefault,
  conditionType,
  companyUnitCostColumn,
  userUnitCostCopyColumn,
  userUnitCostColumn,
  companyUnitCostCopyColumn,
};
